import script from "./Testimonial.vue?vue&type=script&setup=true&lang=js"
export * from "./Testimonial.vue?vue&type=script&setup=true&lang=js"

import "./Testimonial.vue?vue&type=style&index=0&id=1a666091&lang=css"

const __exports__ = script;

export default __exports__